import { el } from 'redom';

import MessagesViewer from './messages-viewer';
import MessageInput from './message-input';
import ConversationActivityDisplay from './conversation-activity-display';

import conversationUpdateTypes from './constants/conversation-update-types';

import './index.scss';

class InternetPhone {

  constructor(configuration) {

    this.conversation = null;
    this.eventSystem = configuration.eventSystem;
    this.messagesViewer = new MessagesViewer({
      ...configuration,
      internetPhone: this
    });
    this.messageInput = new MessageInput({
      ...configuration,
      messagesViewer: this.messagesViewer,
      internetPhone: this
    });
    this.activityDisplay = new ConversationActivityDisplay({
      ...configuration,
      internetPhone: this
    });

    const children = [this.messagesViewer];

    if (configuration.editorSelectionPreview !== void 0) {
      children.push(configuration.editorSelectionPreview);
    }

    if (configuration.enableSuggestions === true) {
      children.push(this.activityDisplay);
    }

    children.push(this.messageInput);

    this.el = el('#internet-phone-main', children);

  }

  updateConversation(conversation) {

    this.conversation = conversation;
    this.messageInput.update(conversation);
    this.activityDisplay.update(conversation);

  }

  async update(conversation, messages) {

    this.updateConversation(conversation);

    await this.messagesViewer.update(conversation, messages);

    this.activityDisplay.update(conversation);

  }

  resetSuggestions() {

    this.conversation.suggestion = {
      for: null,
      options: []
    };

    this.activityDisplay.hideSuggestions();

  }

  isInputEmpty() {

    return this.messageInput.isInputEmpty();

  }

  hideSuggestions() {

    this.activityDisplay.hideSuggestions();

  }

  showSuggestions() {

    if (this.isInputEmpty() === false) {
      return;
    }

    return this.activityDisplay.showSuggestions();

  }

  refreshActivityAndSuggestions(message) {

    this.activityDisplay.tryHideActivity(message);

    if (this.isInputEmpty() === true) {
      this.activityDisplay.tryShowSuggestions();
    }

  }

  setContent(content) {

    this.messageInput.setContent(content);

  }

  updateRecipientsInput() {

    // this.messageInput.updateRecipientsInput(latestMessage);

  }

  inView() {

    this.messagesViewer.inView();

  }

  inBackground() {

    this.messagesViewer.inBackground();

  }

  handleOutboundConversationMessage(payload) {

    this.messagesViewer.handleOutboundConversationMessage(payload);

  }

  trySetDraft(data) {

    this.messageInput.trySetDraft(data);

  }

  tryDisplaySuggestions(data) {

    if (data.updateType !== conversationUpdateTypes.SUGGESTIONS) {
      return;
    }

    const latestMessage = this.messagesViewer.getLatestMessage();

    if (latestMessage === null || latestMessage._id !== data.conversation.lastMessageId) {
      this.hideSuggestions();
      return;
    }

    if (this.isInputEmpty() === false) {
      return;
    }

    this.activityDisplay.update(data.conversation);

  }

  tryDisplayActivity(data) {

    if (data.conversation._id !== this.conversation._id) {
      return;
    }

    if (this.messagesViewer.isExternalMessageDisplayed(data.activity.metadata.messageId)) {

      const message = this.messagesViewer.getMessageByExternalId(data.activity.metadata.messageId);

      if (typeof message.metadata.isFinal === void 0 || message.metadata.isFinal === true) {
        this.activityDisplay.hideActivity();
        return;
      }
    }

    this.activityDisplay.tryDisplayActivity(data);

  }

  hideActivity() {

    this.activityDisplay.hideActivity();

  }

  handleConversationUpdatedEvent(payload) {

    if (payload.conversation._id !== this.conversation._id) {
      return;
    }

    this.messageInput.updateConversation(payload.conversation);
    this.tryDisplaySuggestions(payload);

  }

  getLatestMessage() {

    return this.messagesViewer.getLatestMessage();

  }

  setBookmarks(bookmarks) {

    this.messagesViewer.setBookmarks(bookmarks);
    this.messageInput.bookmarksChanged();

  }

  quoteMessage(message) {

    this.messageInput.setQuotedMessage(message);

  }

  clearQuotedMessage() {

    this.messageInput.clearQuotedMessage();

  }

  bookmarksChanged() {

    this.messagesViewer.messagesUpdated();
    this.messageInput.bookmarksChanged();

  }

  refreshMessageInput() {

    this.messageInput.refresh();

  }

  displayLatestDraft() {

    this.messageInput.displayLatestDraft();

  }

  async onmount() {

    const externalEventCodes = (await import( /* webpackIgnore: true */ 'https://cdn.venturz.co/modules/event-system/codes/external.js')).default;
    this.eventSystem.internal.eventFor(this, externalEventCodes.CONVERSATION_UPDATED, this.handleConversationUpdatedEvent.bind(this));
    this.eventSystem.internal.eventFor(this, externalEventCodes.NEW_CONVERSATION_ACTIVITY, this.tryDisplayActivity.bind(this));
    import( /* webpackIgnore: true */ 'https://cdn.venturz.co/modules/utilities/dom.js');
  }

  onunmount() {

    this.eventSystem.internal.offAllOn(this);

  }

  focus() {

    this.messageInput.focus();

  }

}

export default InternetPhone;
export { default as SuggestionChips } from './suggestion-chips';
